import ClassAttendance from '@/api/class-attendance'
import Term from '@/api/term-semester'
import ClassOperation from '@/api/class-operation'
import { baseState, baseMutations } from '@/store/mixins'
import StudyTime from '@/api/study-time'
import Year from '@/api/academic-year'

export const state = {
  ...baseState,
  teacherOrSubjects: [],
  att_by_subject: [],
  attendenStatus: [],
  presentStatus: [],
  studyTimes: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_TEACHER_OR_SUBJECT(state, data) {
    state.teacherOrSubjects = data
  },
  SET_ATT_BY_SUBJECT(state, data) {
    state.att_by_subject = data
  },
  SET_ATT_STATUS(state, data) {
    state.attendenStatus = data
  },
  SET_PRESENT_STATUS(state, data) {
    state.presentStatus = data
  },
  SET_STUDY_TIMES(state, data) {
    state.studyTimes = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    return ClassAttendance.get({ params: attrubutes }).then(response => {
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return ClassAttendance.store(data)
  },

  getTerm(context, attributes = {}) {
    return Term.get({
      params: Object.assign(
        {
          fields: {
            academic_terms:
              'ac_term_id,term_name,ac_status_id,acps_id,ac_year_id'
          },
          filter: {
            ac_year_id: attributes.ac_year_id
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getYear(context, attributes = {}) {
    return Year.get({
      params: Object.assign(
        {
          fields: {
            academic_years: 'ac_year_id,ac_year,ac_status_id'
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  fetchClasses(context, attributes = {}) {
    if (attributes.ac_term_id === undefined || attributes.ac_term_id === null)
      return { data: [] }

    return ClassOperation.get({
      params: {
        page: -1,
        include: 'teacher',
        fields: {
          academic_classes: 'class_id,class_name,teacher_id,weekday_type_id'
        },
        filter: {
          ac_term_id: attributes.ac_term_id
        }
      }
    }).then(response => {
      return Promise.resolve(response)
    })
  },
  fetchTeachers(context, attributes = {}) {
    if (
      attributes.class_id === undefined ||
      attributes.class_id === null ||
      attributes.att_date === undefined ||
      attributes.att_date === null
    )
      return

    return ClassAttendance.getTeachers({ params: attributes }).then(
      response => {
        context.commit('SET_TEACHER_OR_SUBJECT', response.teacher)
        context.commit('SET_ATT_BY_SUBJECT', response.attendance_by_subject)
        return Promise.resolve(response)
      }
    )
  },

  async dataBeforeCreate(context) {
    if (!context.state.attendenStatus.length > 0) {
      let response = await ClassAttendance.getAttendanceStatus()
      context.commit('SET_ATT_STATUS', response.data)
    }
    if (!context.state.presentStatus.length > 0) {
      let response = await ClassAttendance.getPresentStatus()
      context.commit('SET_PRESENT_STATUS', response.data)
    }
    if (!context.state.studyTimes.length > 0) {
      let params = {
        page: -1,
        include: 'weekday_type',
        fields: {
          academic_study_times:
            'ac_st_id,study_time,session,weekday_type_id,number_of_session'
        }
      }

      return StudyTime.get({ params }).then(response => {
        context.commit('SET_STUDY_TIMES', response.data)
        return Promise.resolve(response)
      })
    }
  },
  getClass(context, attributes = {}) {
    return ClassAttendance.getClasslass(attributes)
  },
  getClassesByTeacher(context, attributes = {}) {
    return ClassAttendance.getClassesByTeacher(attributes)
  },
  getClassByTeacherAndTerm(context, attributes = {}) {
    return ClassAttendance.getClassByTeacherAndTerm(attributes)
  },

}
